<template>
  <div class="container">
    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
      <form @submit.prevent="login">
        <card class="card card-white" header-classes="p-0">
          <template slot="header">
            <img src="img/card-primary.png" alt=""/>
          </template>

          <div>
            <h1 class="card-title text-muted">{{ $t('login.title') }}</h1>
            <base-input
              v-validate="'required|min:3'"
              name="username"
              :error="getError('username')"
              v-model="model.username"
              :placeholder="$t('login.userNamePlaceholder')"
              addon-left-icon="tim-icons icon-single-02"
            >
            </base-input>

            <base-input
              v-validate="'required|min:5'"
              name="password"
              :error="getError('password')"
              v-model="model.password"
              type="password"
              :placeholder="$t('login.passwordPlaceholder')"
              addon-left-icon="tim-icons icon-lock-circle"
            >
            </base-input>
          </div>

          <base-alert v-if="error" type="danger" dismissible>
            {{ $t('login.failedLoginText') }} ({{ error }})
          </base-alert>

          <div slot="footer">
            <base-button native-type="submit" type="primary" class="mb-3" size="lg" block :loading="loading">
              {{ $t('login.loginButtonText') }}
            </base-button>

            <div class="pull-right">
              <router-link to="/forgot-password">
                <i class="tim-icons icon-alert-circle-exc mr-1"></i>{{ $t('navbar.passwordForgot') }}
              </router-link>
            </div>
          </div>
        </card>
      </form>
    </div>
  </div>
</template>
<script>
  import {BaseAlert} from 'src/components'

  export default {
    components: {
      BaseAlert
    },
    data() {
      return {
        error: null,
        model: {
          username: '',
          password: '',
          subscribe: true
        },
        loading: false
      };
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      redirectTo(redirect) {
        const v = this.$auth.user()
        return redirect ? {
          name: redirect.from.name,
          params: redirect.from.params,
          query: redirect.from.query
        } : {name: "home"}
      },
      async login() {
        let isValidForm = await this.$validator.validateAll();
        if (isValidForm) {
          this.error = null;
          this.loading = true;
          // If trying to access guarded resource
          let redirect = this.$auth.redirect();
          // TIP use this.model to send it to api and perform login call
          this.$auth.login({
            body: this.model,
            rememberMe: true,
            fetchUser: true,
            // redirect: this.redirectTo(redirect)
            redirect: null,
          }).then((resp) => {
            this.error = null
            this.loading = false;
            if (redirect) {
              this.$router.push({name: redirect.from.name, params: redirect.from.params, query: redirect.from.query})
              return
            }

            // Depending on role, navigate to proper view.
            switch (this.$auth.user().role) {
              case 'reporter':
              case 'accountant':
                this.$router.push({name: "tickets"})
                break;
              case 'inspector':
              case 'inspector_team_lead':
                this.$router.push({name: "inspector_teams"})
                break;
              case 'service_desk':
              case 'service_desk_l2':
                this.$router.push({name: "search"})
                break;
              case 'super_viewer':
              case 'admin':
                this.$router.push({name: "home"})
                break;
              default:
                this.$router.push({name: "profile"})
            }

            // this.$router.push({name: "home"})
          }).catch((resp) => {
            this.loading = false;
            this.error = resp.statusText
          });
        }
      }
    }
  };
</script>
<style>
  .navbar-nav .nav-item p {
    line-height: inherit;
    margin-left: 5px;
  }
</style>
